import { render, staticRenderFns } from "./HistoricalRateList.vue?vue&type=template&id=4bee08e2"
import script from "./HistoricalRateList.vue?vue&type=script&lang=js"
export * from "./HistoricalRateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports